import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  createApiKey,
  listApiKeys,
  revokeAllApiKeys,
  revokeApiKey,
  type TApiKeyDraft,
} from '../../entities/api-key';

const KEYS = ['api-keys'];

export const useApiKeys = () => {
  const client = useQueryClient();
  const refresh = () => client.invalidateQueries({ queryKey: KEYS });

  const keys = useQuery({ queryKey: KEYS, queryFn: listApiKeys });

  const create = useMutation({
    mutationFn: (draft: TApiKeyDraft) => createApiKey(draft),
    onSuccess: refresh,
  });

  const revoke = useMutation({ mutationFn: revokeApiKey, onSuccess: refresh });

  const revokeAll = useMutation({ mutationFn: revokeAllApiKeys, onSettled: refresh });

  return { keys, create, revoke, revokeAll };
};

export type TApiKeys = ReturnType<typeof useApiKeys>;
